import {Component} from '@angular/core';

/**
 * The marketing half of the auth pages.
 *
 * The login page draws this panel inline; the pages that stand beside it -
 * forgot password, reset password, temporary login - share this one copy rather
 * than each repeating the same markup. The copy keys are the login page's own,
 * so all four pages say the same thing.
 */
@Component({
  selector: 'app-auth-marketing-panel',
  templateUrl: './auth-marketing-panel.component.html',
  styleUrls: ['./auth-marketing-panel.component.css']
})
export class AuthMarketingPanelComponent {
}
